import * as RadixPopover from '@radix-ui/react-popover'
import styled, { css } from 'styled-components'

import { PremiumFeedTable } from '../premium-feed-table/premium-feed-table'

import { PremiumFeedDialogHeader } from './premium-feed-dialog-header'

import type { DialogControlProps } from '@root/shared/ui-kit'

type PremiumFeedDialogProps = {
  children: React.ReactElement
} & DialogControlProps

export const PremiumFeedDialog: React.FC<PremiumFeedDialogProps> = ({
  children,
  onOpenChange,
  open,
}) => {
  return (
    <RadixPopover.Root open={open} onOpenChange={onOpenChange}>
      <RadixPopover.Trigger asChild>{children}</RadixPopover.Trigger>
      <RadixPopover.Portal>
        <Content side="top" align="start" sideOffset={10}>
          <PremiumFeedDialogHeader
            onClose={() => {
              onOpenChange?.(false)
            }}
          />
          <PremiumFeedTable
            css={css`
              height: 100%;
            `}
          />
        </Content>
      </RadixPopover.Portal>
    </RadixPopover.Root>
  )
}

const Content = styled(RadixPopover.Content)`
  display: grid;
  grid-template-rows: auto minmax(0, 1fr);

  width: 560px;
  height: 336px;

  border-radius: 12px;
  border: 1px solid var(--background-3);
  background: var(--background-1);
  box-shadow: 0 -10px 60px 0 rgba(0, 0, 0, 0.84);

  overflow: hidden;
`
